export const data = [
    {
        number:"01",
        desc:"UBI assisted a top-tier Software & Computer manufacturer to automate their monthly P&L report",
        text:"BFSI",
        link:"https://usefulbicorp.sharepoint.com/:v:/r/sites/UBIDemoWebsite/Shared%20Documents/General/Edited%20Demo%20Recordings/PowerBI%20Case%20Study%201.mp4?csf=1&web=1&e=s1gcNa  ",
        radius: '7px 7px 0px 0px'
      },
      {
        number:"02",
        desc:"Revolutionizing Clinical Trial Site Selection Through UBI's Automated Reporting Solution",
        text:"Life Sciences",
        link:"https://usefulbicorp.sharepoint.com/:v:/r/sites/UBIDemoWebsite/Shared%20Documents/General/Edited%20Demo%20Recordings/PowerBI%20Case%20Study%202.mp4?csf=1&web=1&e=Zk6Qmn",
        radius: '0px 0px 7px 7px'
      },
     
  ];